// extracted by mini-css-extract-plugin
export default {"title":"v_-z","warning":"w_-z","sizeOptionsLegendText":"x_-z"};